import { ActionType } from "../action_type";
import {Action} from "../actions/showNavigationAction";


const showNavigationReducer = (state : boolean = true , action : Action) => {
    switch (action.type) {
      case ActionType.SHOW_NAVIGATION:
        return action.payload;
      default :
        return state;
    }
}

export default showNavigationReducer;